import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { auth, db } from './firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import Auth from './components/Auth';
import Home from './components/Home';
import SpacesList from './components/SpacesList';
import Profile from './components/Profile';
import BookingForm from './components/BookingForm';
import SuperuserDashboard from './components/SuperuserDashboard';
import AdminDashboard from './components/AdminDashboard';
import CalendarView from './components/CalendarView';
import { FaArrowLeft } from 'react-icons/fa';

//cose toste per gli alert
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function App() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Imposta lo sfondo sul body rispettando il subpath di deploy
  useEffect(() => {
    const base = window.location.pathname.startsWith('/PrenotaSpazi') ? '/PrenotaSpazi' : '';
    document.body.style.backgroundImage = `url('${base}/sfondo.svg')`;
    document.body.style.backgroundRepeat = 'repeat';
    document.body.style.backgroundSize = '400px 400px';
    document.body.style.backgroundAttachment = 'fixed';
    return () => {
      document.body.style.backgroundImage = '';
    };
  }, []);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {

      // NOTA: Non impostiamo subito setUser(currentUser) qui!
      // Lo facciamo solo DOPO aver controllato che l'account non sia bloccato.

      if (currentUser) {
        try {
          // 1. Scarichiamo i dati utente dal DB
          const docRef = doc(db, "users", currentUser.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();

            // 2. CONTROLLO BLOCCO (Il cuore della modifica)
            if (data.isDisabled) {
              // Se è disabilitato: Logout immediato e stop.
              await signOut(auth);

              toast.error("⛔ ACCESSO NEGATO: Il tuo account è stato disabilitato.", {
                position: "top-center",
                autoClose: 5000,
                theme: "colored"
              });

              // Assicuriamoci che lo stato utente resti null
              setUser(null);
              setUserData(null);
              return; // Interrompiamo qui, così la pagina non cambia
            }

            // 3. Se NON è bloccato, salviamo i dati e facciamo entrare l'utente
            setUserData(data);
            setUser(currentUser); // <--- SOLO ORA attiviamo l'utente, scatenando il cambio pagina
          } else {
            // Caso raro: utente autenticato ma senza dati su Firestore (lo facciamo entrare o gestisci come vuoi)
            setUser(currentUser);
          }
        } catch (error) {
          console.error("Errore lettura dati utente:", error);
          // In caso di errore grave, meglio non loggare
          setUser(null);
        }
      } else {
        // Nessun utente loggato
        setUser(null);
        setUserData(null);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Questo effetto cambia pagina SOLO se 'user' viene impostato (quindi se non è bloccato)
    if (user && location.pathname === '/autenticazione' && user.emailVerified) {
      navigate('/');
    }
  }, [user, location.pathname, navigate]);

  const handleLogout = async () => {
    await signOut(auth);
    setUserData(null);
    navigate('/');
  };

  const goToLogin = () => navigate('/autenticazione', { state: { startRegistering: false, message: '' } });
  const goToRegister = () => navigate('/autenticazione', { state: { startRegistering: true, message: '' } });
  const backToHome = () => navigate('/');
  const goToSpaces = () => navigate('/infoSpazi');
  const goToProfile = () => navigate('/profilo');
  const goToSuperuser = () => navigate('/superuser');
  const goToCalendar = () => navigate('/calendario');
  const goToAdmin = () => navigate('/admin');

  const goToBooking = () => {
    if (user) {
      navigate('/prenotazione');
    } else {
      navigate('/autenticazione', { state: { startRegistering: false, message: "Per prenotare uno spazio devi prima accedere." } });
    }
  };
  return (
    <div>

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Routes>
        <Route path="/" element={
          <Home
            user={user}
            userData={userData}
            onLoginClick={goToLogin}
            onRegisterClick={goToRegister}
            onLogout={handleLogout}
            onSpacesClick={goToSpaces}
            onProfileClick={goToProfile}
            onBookingClick={goToBooking}
            onSuperuserClick={goToSuperuser}
            onAdminClick={goToAdmin}
            onCalendarClick={goToCalendar}
          />
        } />

        <Route path="/autenticazione" element={
          <div style={{

            minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px', position: 'relative'
          }}>
            <button
              onClick={backToHome}
              style={{
                position: 'absolute', top: '25px', left: '25px',
                display: 'flex', alignItems: 'center', gap: '8px',
                background: 'white', padding: '10px 20px', borderRadius: '30px',
                border: 'none', cursor: 'pointer', fontSize: '14px', color: '#222', fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(0,0,0,0.1)', zIndex: 10, transition: 'transform 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <FaArrowLeft /> Torna alla Home
            </button>

            <div className="glass-panel auth-container responsive-padding" style={{
              padding: '30px', // Verrà sovrascritto dalla media query .glass-panel se < 768px
              borderRadius: '24px',
              maxWidth: '700px',
              width: '90%', // Usa il 90% su mobile rispetto al 100% fisso
              marginTop: '80px', // Più margine in alto per il bottone torna indietro
              marginBottom: '40px',
              boxSizing: 'border-box'
            }}>
              <Auth
                key={location.state?.startRegistering ? 'reg' : 'log'}
                startRegistering={location.state?.startRegistering || false}
                initialMessage={location.state?.message || ''}
              />
            </div>
          </div>
        } />

        <Route path="/infoSpazi" element={<SpacesList onBack={backToHome} onBookingClick={goToBooking} />} />
        <Route path="/profilo" element={<Profile user={user} onBack={backToHome} onLogout={handleLogout} />} />
        <Route path="/prenotazione" element={<BookingForm user={user} onBack={backToHome} />} />
        <Route path="/calendario" element={<CalendarView onBack={backToHome} user={user} userData={userData} />} />

        <Route path="/superuser" element={
          userData?.role === 'superuser' ? (
            <SuperuserDashboard onBack={backToHome} />
          ) : (
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontFamily: 'Poppins' }}>
              <h1 style={{ color: 'red', fontSize: '30px' }}>⛔ Accesso Negato</h1>
              <button onClick={backToHome}>Torna alla Home</button>
            </div>
          )
        } />

        <Route path="/admin" element={
          (userData?.role === 'admin' || userData?.role === 'superuser') ? (
            <AdminDashboard onBack={backToHome} />
          ) : (
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontFamily: 'Poppins' }}>
              <h1 style={{ color: 'red', fontSize: '30px' }}>⛔ Accesso Negato</h1>
              <button onClick={backToHome}>Torna alla Home</button>
            </div>
          )
        } />
      </Routes>

    </div>
  );
}

export default App;